import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Input, Text, Box } from '@chakra-ui/react';

export default function InlineEdit({ value, onSave, type = 'text', placeholder = '' }) {
  const [editing, setEditing] = useState(false);
  const [localValue, setLocalValue] = useState(value || '');
  const inputRef = useRef(null);
  const editingRef = useRef(false);
  const savingRef = useRef(false);

  useEffect(() => {
    // Only sync from props when NOT actively editing AND not in the middle of saving
    if (!editingRef.current && !savingRef.current) {
      setLocalValue(value || '');
    }
  }, [value]);

  useEffect(() => {
    if (editing && inputRef.current) {
      inputRef.current.focus();
      if (type === 'text') inputRef.current.select();
    }
  }, [editing, type]);

  const handleSave = useCallback(() => {
    if (savingRef.current) return; // Prevent double-save
    savingRef.current = true;
    editingRef.current = false;
    setEditing(false);
    if (localValue !== (value || '')) {
      onSave(localValue);
    }
    // Allow prop sync again after a brief delay (wait for parent to process)
    setTimeout(() => { savingRef.current = false; }, 500);
  }, [localValue, value, onSave]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleSave();
    if (e.key === 'Escape') { editingRef.current = false; savingRef.current = false; setLocalValue(value || ''); setEditing(false); }
  };

  if (editing) {
    return (
      <Input
        ref={inputRef}
        size="xs"
        type={type}
        value={localValue}
        onChange={(e) => setLocalValue(e.target.value)}
        onBlur={handleSave}
        onKeyDown={handleKeyDown}
        variant="flushed"
        fontSize="12px"
        px={2}
        h="24px"
      />
    );
  }

  return (
    <Box
      cursor="pointer"
      onClick={() => { editingRef.current = true; setEditing(true); }}
      minH="20px"
      fontSize="12px"
      color={value ? 'gray.800' : 'gray.400'}
      _hover={{ borderRadius: 'sm' }}
      px={1}
      py={0.5}
      title={value || placeholder}
    >
      <Text noOfLines={1}>
        {type === 'date' && value ? (() => {
          const d = value.split('T')[0]; const [y,m,day] = d.split('-').map(Number);
          return new Date(y, m-1, day).toLocaleDateString('en-GB');
        })() : (value || placeholder || '—')}
      </Text>
    </Box>
  );
}
